import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { useGetTokens } from "../../hooks/useGetTokens"
import { FaPhoneVolume } from "react-icons/fa"

import styles from "../../styles/global.module.scss"

const StickyCta = () => {
  // determined if page has scrolled and if the view is on mobile
  const [scrolled, setScrolled] = useState(false)

  // change state on scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 80
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled)
      }
    }

    document.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      // clean up the event handler when the component unmounts
      document.removeEventListener("scroll", handleScroll)
    }
  }, [scrolled])

  const phone = useGetTokens()

  return (
    <div data-active={scrolled} className={styles.stickyCta}>
      <Link to="/request-a-quote/">Work With Us</Link>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`tel: ${phone.CompanyPhone}`}
      >
        <FaPhoneVolume /> Call Us
      </a>
    </div>
  )
}
export default StickyCta
